<template>
  <div
    style="height: 90vh; width: 90vw; position: relative; z-index: 999"
    class="d-flex flex-column align-items-center background"
  >
    <button style="position: absolute; top: 25px; right: 25px; z-index: 999">
      <img
        @click="$emit('close')"
        src="@/assets/icons/Close Button.svg"
        style="height: 23px; width: auto"
      />
    </button>

    <div
      class="d-flex flex-column align-center justify-center flex-grow-1"
      style="font-size: 30px; z-index: 99"
    >
      <div
        style="border: 2px solid white; width: 250px"
        class="pa-4 mb-8 text-center"
        @click="onArClick('doll')"
      >
        {{ $t("ar_targets.doll") }}
      </div>
      <div
        style="border: 2px solid white; width: 250px"
        class="pa-4 text-center"
        @click="onArClick('cycl')"
      >
        {{ $t("ar_targets.cycl") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentPoi: Object,
  },
  components: {},

  data() {
    return {
      loader: true,
      progress: 0,
      currentModel: null,
      currentModelIndex: null,
    };
  },

  methods: {
    onArClick(name) {
      let url = null;
      if (name == "doll") {
        url = this.currentPoi.ar_uri.split("&&")[0].replace(/\s/g, "");
      } else if (name == "cycl") {
        url = this.currentPoi.ar_uri.split("&&")[1].replace(/\s/g, "");
      }
      this.$emit("openAr", url);
      this.$emit("close");
    },
  },
};
</script>

<style></style>
